/** Minimal forward-only byte reader mirroring how the C# code reads the map stream. */
export class ByteStream {
  private pos = 0;
  constructor(private readonly bytes: Uint8Array) {}

  /** Returns next byte (0..255) or -1 at end of stream. */
  readByte(): number {
    if (this.pos >= this.bytes.length) return -1;
    return this.bytes[this.pos++];
  }

  /** Reads `count` bytes into a new array (short read possible near EOF). */
  readBytes(count: number): Uint8Array {
    const end = Math.min(this.pos + count, this.bytes.length);
    const out = this.bytes.subarray(this.pos, end);
    this.pos = end;
    return out;
  }

  skip(count: number): void {
    this.pos = Math.min(this.pos + count, this.bytes.length);
  }

  get eof(): boolean {
    return this.pos >= this.bytes.length;
  }
}
